<div class="mention-panel">
  @for (user of users; track user) {
    <button
      type="button"
      class="mention-item"
      (mousedown)="selectUser(user)">
      <span>&#64;</span>{{ user.username }}
    </button>
  }
</div>
